import { BodyText } from '@/components/BodyText';
import { Ellipsis } from '@/components/Ellipsis';

import { Close } from '@mui/icons-material';
import { Box, useTheme } from '@mui/material';
import React from 'react';

export const FilterTriggerContent: React.FC<{
  filterName?: string;
  open: boolean;
  checkedItems: string[];
  getAppliedSelection: () => string[];
  findLabel: (filterValue: string) => string;
  onRemoveValue?: (filterValue: string) => void;
  staleFilterValues?: string[];
}> = ({ filterName, open, checkedItems, getAppliedSelection, findLabel, onRemoveValue, staleFilterValues = [] }) => {
  const theme = useTheme();
  return (
    <>
      <BodyText color='text.secondary' marginBottom='4px' textAlign='left' display='block' width={'100%'}>
        {filterName}
      </BodyText>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          flexWrap: 'wrap',
          backgroundColor: 'transparent',
          border: 'none',
          padding: '0',
          maxWidth: '220px',
        }}
      >
        {(open ? checkedItems : getAppliedSelection()).map(filterValue => {
          const label = findLabel(filterValue);
          const isStale = staleFilterValues.includes(filterValue);
          return (
            <Box
              key={filterValue}
              sx={{
                backgroundColor: theme.palette.background.paper,
                borderRadius: '6px',
                padding: '2px 8px',
                border: `1px solid ${theme.palette.divider}`,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                maxWidth: '195px',
                overflow: 'hidden',
                opacity: isStale ? 0.5 : 1,
              }}
            >
              <BodyText fontWeight='500' sx={{ flex: 1, minWidth: 0, color: theme.palette.text.primary }}>
                <Ellipsis text={label} />
              </BodyText>
              {onRemoveValue && (
                <Close
                  onClick={event => {
                    event.stopPropagation();
                    onRemoveValue(filterValue);
                  }}
                  sx={{
                    fontSize: '14px',
                    cursor: 'pointer',
                    color: theme.palette.text.secondary,
                    flexShrink: 0,
                    '&:hover': {
                      color: theme.palette.text.primary,
                    },
                  }}
                />
              )}
            </Box>
          );
        })}
      </Box>
    </>
  );
};
